import React, { useState } from 'react'
import { Box, Typography, Collapse, Grid, makeStyles, Chip, ListItem } from "@material-ui/core"
import ArrowRight from '@material-ui/icons/ArrowRight'
import Chart from "react-google-charts";
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import { useTranslate } from 'react-admin'
import Checkbox from '../checkbox'




const useStyles = makeStyles(theme => ({
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },

    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    }
}));


const ChartItem = ({ data }) => {
    // const [data, setData] = useState([
    //     ['Task', 'Hours per Day'],
    //     ['Info channel', 11],
    //     ['TV Mode', 4],
    //     ['Menu Mode', 5],
    //     ['Offline', 6]
    // ]);
    const options = {
        title: data.name,
        titleTextStyle: { fontSize: 16 },
        chartArea: { left: 0, top: 20, width: '100%', height: '75%' },
        legend: {
            alignment: 'center'
        },
    }
    return (
        <Box>
            <Chart
                width={'400px'}
                height={'300px'}
                chartType="PieChart"
                loader={<div>Loading Chart</div>}
                data={[['Task', 'Hours per Day'], ...data.menu]}
                options={options}
                rootProps={{ 'data-testid': '1' }}
            />
        </Box>
    )
}

const InfoPageChart = ({ data, setData }) => {
    const [expand, setExpand] = useState(true)
    const [openInfopage, setOpenInfopage] = useState(false)
    const classes = useStyles()
    const translate = useTranslate()

    const handleOpenInfopage = () => {
        setOpenInfopage(!openInfopage)
    }

    const onChangeCheckBox = (index) => {
        let temps = data.slice()
        temps[index].checked = temps[index].checked !== undefined ? !temps[index].checked : true
        setData(temps)
    }

    return (
        <Box>
            <Box display='flex' alignContent='center' style={{ cursor: 'pointer' }} onClick={() => setExpand(!expand)}>
                <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Book' }}>Info Page - Node Selection</Typography>
                <ArrowRight fontSize='large' style={{ transform: `rotate(${expand ? 90 : 0}deg)` }}></ArrowRight>
            </Box>
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <Box>
                    <Box width={500} my={2} bgcolor='#F5F7FB' p={2}>
                        <SelectBox
                            label={"Info page"}
                            value={
                                !data || data.filter(element => element.checked).length === 0 ? '' :
                                    <Box display='flex'>
                                        {
                                            data.filter((element) => element.checked).map((data, index) => {
                                                if (index < 5)
                                                    return (
                                                        <Chip
                                                            color='primary'
                                                            size='small'
                                                            style={{ marginRight: 8 }}
                                                            key={data.id}
                                                            label={data.name}
                                                        />
                                                    )
                                            }
                                            )

                                        }
                                        {
                                            data.filter((element, index) => element.checked).length > 5 && <Typography variant='body1'>{translate(`pos.channels.more`)}</Typography>
                                        }

                                    </Box>
                            }
                            open={openInfopage}
                            handleClick={handleOpenInfopage}
                        >
                            {
                                data.map((data, index) => (
                                    <ListItem onClick={() => onChangeCheckBox(index)} key={'item-' + index} style={{ padding: '8px' }} button className={classes.boxBoder}>
                                        <Checkbox color='primary' checked={data.checked === undefined ? false : data.checked}></Checkbox>
                                        <Typography className={classes.TextValue}>{data.name}</Typography>
                                    </ListItem>
                                ))
                            }

                        </SelectBox>
                    </Box>
                    <Grid container>
                        {
                            data.filter(item => item.checked).map((item, index) => (
                                <Grid key={'infopage' + '_' + index} item style={{ marginTop: 8 }}>
                                    <ChartItem data={item} />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Box>
            </Collapse>
        </Box>
    )
}
export default InfoPageChart